import React from "react";
import { GdvEntryModel, HsnTsnModel } from "../../api/hsntsnApi";
import { Form, Table } from "react-bootstrap";

interface GdvHsnHsnProps {
  entries: GdvEntryModel[];
  selectedEntries: HsnTsnModel[];
  selectionChanged: (hsn: string, tsn: string, selected: boolean) => void;
}

function GdvHsnTsn({
  entries,
  selectedEntries,
  selectionChanged,
}: GdvHsnHsnProps) {
  const isSelected = (entry: GdvEntryModel) => {
    return (
      selectedEntries.findIndex(
        (x) => x.hsn === entry.hsn && x.tsn === entry.tsn
      ) >= 0
    );
  };

  return (
    <Table>
      <thead>
        <tr>
          <th>Include</th>
          <th>HSN</th>
          <th>TSN</th>
          <th>Marke</th>
          <th>Fahrzeugtype</th>
          <th>Leistung (PS)</th>
          <th>Leistung (KW)</th>
          <th>Hubraum</th>
          <th>Kraftstoff</th>
        </tr>
      </thead>
      <tbody>
        {(entries.length ?? 0) === 0 ? (
          <tr>
            <td colSpan={9}>No GDV entries...</td>
          </tr>
        ) : (
          entries.map((x) => (
            <tr key={`${isSelected(x)}_${x.hsn}_${x.tsn}`}>
              <td>
                <Form.Check
                  defaultChecked={isSelected(x)}
                  onChange={(e) =>
                    selectionChanged(x.hsn!, x.tsn!, e.target.checked)
                  }
                />
              </td>
              <td>{x.hsn}</td>
              <td>{x.tsn}</td>
              <td>{x.marke}</td>
              <td>{x.fahrzeugtype}</td>
              <td>{x.leistungPs}</td>
              <td>{x.leistungKw}</td>
              <td>{x.hubraum}</td>
              <td>{x.kraftstoff}</td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
}

export default GdvHsnTsn;
